import { Notification } from 'element-ui'

import { removeToken, setToken, getToken } from '@/utils/cookie'

const logoutDuration = 30 * 60 * 1000 // 30min退出登录
let countTenToClose = null // 10秒倒计时退出登录延迟实例
let notificationInstance = null // 提示框实例
let AUTO_LOGIN_OUT
const clearFun = () => {
  if (getToken('Miit-Token')) {
    let duration = new Date().getTime() - parseInt(getToken('Miit-Active') || 0)
    if (duration < logoutDuration) {
      clearTimeout(AUTO_LOGIN_OUT)
      clearTimeout(countTenToClose)
      AUTO_LOGIN_OUT = setTimeout(clearFun, duration)
      return
    }
    notificationInstance = Notification({
      title: '提示',
      message: '由于长时间未操作，将于10秒后退出当前登录状态(点击页面任意位置可取消此次操作)。',
      type: 'warning',
      duration: 10000
    })
    countTenToClose = setTimeout(() => {
      duration = new Date().getTime() - parseInt(getToken('Miit-Active') || 0)
      if (duration < logoutDuration) {
        clearTimeout(AUTO_LOGIN_OUT)
        clearTimeout(countTenToClose)
        AUTO_LOGIN_OUT = setTimeout(clearFun, duration)
        return
      }
      removeToken('Miit-Token')
      window.location.href = '/users/index'
    }, 10000)
  }
}
// 页面初始化增加时间戳
setToken('Miit-Active', new Date().getTime())

AUTO_LOGIN_OUT = setTimeout(clearFun, logoutDuration)

// 页面点击重启一个定时器
document.body.addEventListener('click', () => {
  if (notificationInstance) notificationInstance.close()
  setToken('Miit-Active', new Date().getTime())
  clearTimeout(AUTO_LOGIN_OUT)
  clearTimeout(countTenToClose)
  AUTO_LOGIN_OUT = setTimeout(clearFun, logoutDuration)
})
